import React from "react";
import { Link, withRouter } from "react-router-dom";
import defaultThumb from "assets/img/defaults/default-thumbnail.jpg";
import Modal from "../../shared/Modal";

const MapData = props => {
    let content = "No available updates.";

    function validateImg(imgSrc) {
        let img = imgSrc;
        const regex = /.+[.](jpg|png|jpeg|svg|gif)/g;

        if (regex.test(img) === true) {
            return (
                "https://explusmobile.worldvision.org.ph/explus-mobile/developer/laravel-backend/public/temp/" +
                img
            );
        } else {
            return defaultThumb;
        }
    }

    if (props.items !== undefined && props.items.length > 0) {
        content = props.items.map((item, index) => {
            const date = new Date(item.created_at);
            const month = date.getMonth();
            const day = date.getDate();
            const year = date.getFullYear();
            const dateNames = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ];

            // console.log(month)

            // const fullDate = dateNames[month-1] + ' ' + day + ', ' + year
            const fullDate = dateNames[month] + " " + day + ", " + year;

            return (
                <li key={index} className="list-group-item">
                    <div className="row">
                        <div className="col-sm-3">
                            <img
                                className="img-thumbnail"
                                src={validateImg(item.image)}
                                alt="thumbnail"
                            />
                            <div style={{ marginBottom: "10px" }} />
                            <Modal content={item.video} type="video" />
                        </div>

                        <div className="col-sm-9">
                            <h4 className="list-group-item-heading">
                                {item.title}
                            </h4>
                            <small className="release-date">
                                <i
                                    className="fa fa-calendar"
                                    aria-hidden="true"
                                />{" "}
                                {fullDate}
                            </small>
                            <p className="list-group-item-text">
                                {item.short_description}{" "}
                                <Link to={`/dashboard/my-updates/${item.id}`}>
                                    Read More
                                </Link>
                            </p>
                        </div>
                    </div>
                </li>
            );
        });
    }

    return <ul className="list-group">{content}</ul>;
};

export default withRouter(MapData);
